import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation
} from 'react-router-dom';

import Header from './components/Header';
import Footer from './components/Footer';
import Landing from './components/Landing';
import FormularioTrabajo from './components/FormularioTrabajo';
import Login from './components/Login';
import Panel from './components/Panel';

// No necesitamos importar DataTables CSS aquí, lo manejaremos en Panel.js
// y agregaremos los CDN necesarios en el index.html

function AppLayout() {
  const location = useLocation();
  const hideLayout = location.pathname === '/login' || location.pathname === '/panel'; // Oculta header/footer en /login y /panel
  
  return (
    <>
      {!hideLayout && <Header />}
      <main>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/trabaja-con-nosotros" element={<FormularioTrabajo />} />
          <Route path="/login" element={<Login />} />
          <Route path="/panel" element={<Panel />} />
        </Routes>
      </main>
      {!hideLayout && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}